/* esm.sh - @radix-ui/react-use-size@1.1.1 */
export * from "/*@radix-ui/react-use-size@1.1.1/esnext/react-use-size.mjs";
